





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ManualFeesDialogForm from '@/components/Products/ProductFees/Manual/ManualFeesDialogForm.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import UpdateManualFeeRequest from '@/models/Products/ProductFees/UpdateManualFeeRequest';

@Component({ name: 'ManualFeesEditDialog', components: { ManualFeesDialogForm } })
export default class extends SaascadaVueDialog {

    dialog = false;
    manualFeeRequest: UpdateManualFeeRequest = new UpdateManualFeeRequest(this.currentManualFee);

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.manualFeeRequest = new UpdateManualFeeRequest(this.currentManualFee);
        }
    }

    get currentManualFee() {
        return ProductDetailsModule.currentManualFee;
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editManualFee(this.manualFeeRequest);
        }
    }

}
